package com.anjuros.website.components.shared

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.ResKey
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.redesign.components.TemplateGetWebsitePill
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template6.util.Template6Constants.DEV_WEB
import com.anjuros.website.templates.template6.util.Template6Constants.FONT_FAMILY
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOut
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import kotlin.js.Date
import kotlin.math.exp

@Composable
fun AnjurosImage(
    modifier: Modifier,
    src : String,
    alt:String=""

){
    val placeholderImage = if(LocalUiMode.current==UiMode.PLACEHOLDER) "content_placeholder.jpg" else src
    AnjurosPlaceholder(
        modifier = modifier,
        source = placeholderImage,
        alt = alt
    )
}

@Composable
fun AnjurosVideo(
    modifier: Modifier,
    sourceContent: @Composable () -> Unit

){
    if(LocalUiMode.current==UiMode.PLACEHOLDER) {
        AnjurosPlaceholder(
            modifier = modifier,
            source = "content_video_placeholder.jpg",
            alt = "video"
        )
    } else {
        sourceContent()
    }
}

@Composable
private fun AnjurosPlaceholder(
    modifier: Modifier,
    source : String,
    alt:String=""
){
    Image(
        modifier = modifier,
        src = source,
        alt = alt
    )
}

@Composable
fun AnjurosIcon(
    modifier: Modifier=Modifier,
    src : String,
    alt:String=""

){
    val placeholderImage = if(LocalUiMode.current==UiMode.PLACEHOLDER) "icon_placeholder.png" else src
    Image(
        modifier = modifier.then(
            if(LocalUiMode.current==UiMode.PLACEHOLDER){
                Modifier.size(40.px)
            } else {
                Modifier
            }
        ),
        src = placeholderImage,
        alt = alt
    )
}

@Composable
fun AnjurosLogo(
    modifier: Modifier=Modifier,
    src : String,
    alt:String=""

){
    val placeholderImage = if(LocalUiMode.current==UiMode.PLACEHOLDER) "logo_placeholder.png" else src
    Image(
        modifier = modifier.then(
            if(LocalUiMode.current==UiMode.PLACEHOLDER){
                Modifier.size(100.px)
            } else {
                Modifier
            }
        ),
        src = placeholderImage,
        alt = alt
    )
}

@Composable
fun AnjurosBackgroundImage(
    modifier: Modifier,
    src : String,
    alt:String=""

){
        Image(
            modifier = modifier,
            src = src,
            alt = alt
        )
        if(LocalUiMode.current== UiMode.PLACEHOLDER){
            Box(
                modifier = Modifier.backgroundColor(Theme.Primary.rgb)
                    .size(100.percent)
            )
        }
}

@Composable
fun AnjurosText(
    text:String,
    placeholder: ResKey
){
    if(LocalUiMode.current== UiMode.PLACEHOLDER){
        Text(LocalText(placeholder))
    } else {
        Text(text)
    }

}

@Composable
fun AnjurosText(
    text:String,
    placeholder: CompanyDetailsType
){
    if(LocalUiMode.current== UiMode.PLACEHOLDER){
        AnjurosText(placeholder)
    } else {
        Text(text)
    }

}

@Composable
fun AnjurosText(
    text: CompanyDetailsType
){
    val mappedText = if(LocalUiMode.current== UiMode.PLACEHOLDER) text.getType().placeholder() else text.value()
    Text(mappedText)
}

fun DetailsType.placeholder():String{
    return when(this){
        DetailsType.EMAIL -> "yourcompany@gmail.com"
        DetailsType.COMPANY -> "Your company name"
        DetailsType.COMPANY_NUMBER -> "Your company number"
        DetailsType.COMPANY_ADDRESS -> "Your company address"
        DetailsType.COMPANY_PHONE -> "07123456789"
        DetailsType.COMPANY_FACEBOOK -> "facebook@yourcompany"
        DetailsType.COMPANY_SERVICE_AREA -> "Your service area"
        DetailsType.COMPANY_SERVICE_AREA_ADDRESS -> "Area address"
        DetailsType.COMPANY_OPENING_HOURS -> "Your opening hours"
        DetailsType.COMPANY_INSTAGRAM -> "@yourinstagram"
        DetailsType.COMPANY_NAME -> "Your name"
    }
}
enum class DetailsType{
    EMAIL, COMPANY, COMPANY_NUMBER,COMPANY_ADDRESS, COMPANY_PHONE,COMPANY_NAME,
    COMPANY_FACEBOOK, COMPANY_INSTAGRAM,COMPANY_SERVICE_AREA, COMPANY_SERVICE_AREA_ADDRESS, COMPANY_OPENING_HOURS,
}

interface CompanyDetailsType{
    fun value():String
    fun getType(): DetailsType

}

@Composable
fun AnjurosCopyright(modifier: Modifier){
    val date = remember { Date().getFullYear() }
    Link(
        modifier = modifier
            .margin(top=10.px)
            .fontFamily(FONT_FAMILY)
            .fontSize(12.px)
            .fontWeight(FontWeight.Bold)
            .textDecorationLine(TextDecorationLine.None)
            .color(Colors.White),
        path = DEV_WEB,
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        Text("Copyright © $date Anjuros Development, All rights reserved.")
    }
}

@Composable
fun AnjurosCopyrightStyled(modifier: Modifier){
    val date = remember { Date().getFullYear() }
    Link(
        modifier = modifier,
        path = DEV_WEB,
        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
    ) {
        Text("Copyright © $date Anjuros Development, All rights reserved.")
    }
}

/** The "Like this design? Get this website" button floating over every template preview. */
@Composable
fun TemplatePromoFab() {
    TemplateGetWebsitePill()
}
